import {Box, Grid, Typography} from "@material-ui/core";
import FilmCategoryForm from "./filmCategoryForm";
import React, {useState} from "react";
import apiHelper from "../../../util/ApiHelper";
import {toast} from "react-toastify";
import {useLoading} from "../../../util/LoadingProvider";

const formDefaultValues = (seq) => ({
    id: 0,
    backgroundColor: "#000000",
    seq,
    status: true,
    categoryId: -1,
    localizations: {
        en: {
            name: ""
        },
        tc: {
            name: ""
        }
    }
})

export default function FilmSubCategoryEditPage(props) {
    const {disabled, match} = props;
    const {setLoading} = useLoading();
    const {subCatId} = match.params;
    const [paramId, setParamId] = useState(subCatId);
    const [categorySelection, setCategorySelection] = useState([]);
    const [formDefaultData, setFormDefaultData] = useState(formDefaultValues(0));
    const getCategorySelection = React.useCallback(async () => {
        try {
            setLoading(true);
            const result = await apiHelper.hkiff.getFilmCategories(
                null,
                0,
                0,
                9999999,
                ''
            );
            console.log('getCategorySelection: ', result);
            setCategorySelection(result.data.content.map((category) => (
                {
                    id: category.id,
                    localizations: {
                        en: {
                            name: category.localizations.en.name
                        }
                    }
                }
            )));
        } catch (e) {
            console.log(e);
        } finally {
            setLoading(false);
        }
    }, [setLoading])

    const getSubCategoryById = React.useCallback(async () => {
        try {
            setLoading(true);
            if (paramId !== undefined) {
                const result = await apiHelper.hkiff.getFilmSubCategoryById(paramId);
                console.log('getSubCategoryById: ', result);
                setFormDefaultData({
                    ...result.data,
                    backgroundColor: result.data.backgroundColor ? `#${result.data.backgroundColor}` : null
                });
            }
        } catch (e) {
            console.log(e);
        } finally {
            setLoading(false);
        }
    }, [paramId])

    const updateSubCategory = async (id, data) => {
        try {
            setLoading(true);
            const result = await apiHelper.hkiff.updateFilmSubCategoryById(id, data);
            if (result.data.id) {
                toast.dark("Your changes are saved.");
            }
            console.log(result);
        } catch (e) {
            console.log(e);
        } finally {
            setLoading(false);
        }
    }

    const submitApi = (data, callback) => {
        data.backgroundColor = data.backgroundColor ? data.backgroundColor.replace('#', '') : null;
        updateSubCategory(data.id, data);
    }

    React.useEffect(() => {
        getCategorySelection();
        getSubCategoryById();
    }, [getSubCategoryById, getCategorySelection, paramId])

    return (
        <>
            <Box width="100%">
                <Typography variant="h4" gutterBottom>
                    Film > Edit Film Subcategory
                </Typography>
            </Box>
            <Grid container xs={6}>
                <FilmCategoryForm
                    title={'Edit Subcategory'}
                    buttonLabel={'Save Changes'}
                    categorySelectArray={categorySelection}
                    shouldCategoryIncludeMain={false}
                    shouldCategoryUseMain={false}
                    defaultData={formDefaultData}
                    submitApi={submitApi}
                    disabled={disabled}
                />
            </Grid>
        </>
    );
}
